import { useNavigate } from "react-router-dom";

import apiVor from "api/vor";
import { getEnvVal } from "core/env.js";
import { searchNestedIterableItem } from "core/iterable_utils";

const useNavigateToVorViewerRow = () => {
	const navigate = useNavigate();

	const openVorRowByKey = ({ projectId, vorId, key }) => {
		apiVor.getViewerData({ vorId }).then((response) => {
			const tableData = response.data.table_data;
			const seekObj = searchNestedIterableItem({
				iterable: tableData,
				isSeekRowCallback: (item) => {
					if (item.key && item.key === key) {
						return true;
					} else {
						return false;
					}
				},
				isPermittedRowCallback: () => true,
				isPermittedChildsLoopCallback: () => true,
			});

			localStorage.setItem("displayScrollTop", seekObj.seekCount);
			localStorage.setItem("scrollKey", key);

			if (getEnvVal("App") === "guest") {
				navigate(`/project/${projectId}/vor/${vorId}/`);
			} else {
				window.open(`/project/${projectId}/vor/${vorId}/`);
			}
		});
	};

	return { openVorRowByKey };
};

export default useNavigateToVorViewerRow;
